module.exports = __webpack_public_path__ + "media/packs/images/shipping-instruction-051842c4534a0b389dd73763121872d3.svg";